/* COMPONENT IMPORTS*/
import DesktopNavbar from "./Navbar/DesktopNavbar";
import { Sidebar } from "./Sidebar/Sidebar";
import ContextConstructor from "./Context/Context";

/* MODULE IMPORTS */
import { Container } from "reactstrap";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";

class Layout extends Component {
  static displayName = Layout.name;

  render() {
    const { isLoggedIn } = this.context;

    const pathname = this.props.location?.pathname || "";

    const classeDiv =
      pathname === "/" ? "with-background-image" : "";

    const classBeneficiosDiv =
      pathname === "/beneficios" ||
      pathname === "/cartaoassociado"
        ? "beneficios-container"
        : "";

    if (isLoggedIn) {
      return (
        <div className={classeDiv}>
          <DesktopNavbar />
          <Sidebar className="fixed-sidebar" />

          <Container className={classBeneficiosDiv}>
            {this.props.children}
          </Container>
        </div>
      );
    }

    return (
      <div>
        <Container>{this.props.children}</Container>
      </div>
    );
  }
}

Layout.contextType = ContextConstructor;

export default withRouter(Layout);